const Styles = {
  gridStyle: {
    marginTop: 15,
    marginBottom: 15,
  },
};
export default Styles;
